"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSX_EMAIL_TEMPLATE_NAMES = exports.TsxEmailTemplateName = void 0;
/**
 * Supported TSX email template names.
 * Add new templates here as they are created.
 *
 * When adding a new template:
 * 1. Add the template name to this enum
 * 2. Add the render function in emailTemplateController.ts
 * 3. The new template will automatically be available in:
 *    - Route validation (communicationRouter.ts)
 *    - Email Template Viewer (EmailTemplateViewer.vue)
 */
var TsxEmailTemplateName;
(function (TsxEmailTemplateName) {
    TsxEmailTemplateName["example"] = "example";
    TsxEmailTemplateName["appraisalReportDelivery"] = "appraisalReportDelivery";
    TsxEmailTemplateName["avmPropertyValuationDelivery"] = "avmPropertyValuationDelivery";
    TsxEmailTemplateName["purchaseHelocPreQualLetterDelivery"] = "purchaseHelocPreQualLetterDelivery";
    TsxEmailTemplateName["purchaseHelocPreApprovalLetterDelivery"] = "purchaseHelocPreApprovalLetterDelivery";
    TsxEmailTemplateName["texasPreNotaryDisclosures"] = "texasPreNotaryDisclosures";
    /** Emails the Account Agreement (the §50(a)(6)(M)(ii) final itemized fee disclosure) to the Texas owners */
    TsxEmailTemplateName["texasAccountAgreementDelivery"] = "texasAccountAgreementDelivery";
    /** Email sending closing documents (e.g. notary packet) to applicants */
    TsxEmailTemplateName["closingDocumentsDelivery"] = "closingDocumentsDelivery";
    TsxEmailTemplateName["lienRefiComplete"] = "lienRefiComplete";
    TsxEmailTemplateName["lienStackingFinalNotice"] = "lienStackingFinalNotice";
    TsxEmailTemplateName["lienStackingBlocked"] = "lienStackingBlocked";
    TsxEmailTemplateName["preQualOfferDripRefi"] = "preQualOfferDripRefi";
    TsxEmailTemplateName["finalOfferDripRefi"] = "finalOfferDripRefi";
    TsxEmailTemplateName["offerEligibilityReviewOffer"] = "offerEligibilityReviewOffer";
    TsxEmailTemplateName["offerEligibilityReviewDenial"] = "offerEligibilityReviewDenial";
    TsxEmailTemplateName["secondaryAccountLoginDisabled"] = "secondaryAccountLoginDisabled";
    TsxEmailTemplateName["adcOverrideRequest"] = "adcOverrideRequest";
    TsxEmailTemplateName["cryptoPreQualOffer"] = "cryptoPreQualOffer";
    TsxEmailTemplateName["cryptoOffer"] = "cryptoOffer";
    TsxEmailTemplateName["cryptoAccepted"] = "cryptoAccepted";
    TsxEmailTemplateName["cryptoWelcome"] = "cryptoWelcome";
    // ======= Crypto Collateral / LTV Events =======
    TsxEmailTemplateName["cryptoAtRiskOfBeingLocked"] = "cryptoAtRiskOfBeingLocked";
    TsxEmailTemplateName["cryptoAccountLocked"] = "cryptoAccountLocked";
    TsxEmailTemplateName["cryptoAccountUnlocked"] = "cryptoAccountUnlocked";
    TsxEmailTemplateName["cryptoUrgentPartialLiquidationWarning"] = "cryptoUrgentPartialLiquidationWarning";
    TsxEmailTemplateName["cryptoPartialLiquidationRiskCleared"] = "cryptoPartialLiquidationRiskCleared";
    TsxEmailTemplateName["cryptoNoticeOfPartialLiquidation"] = "cryptoNoticeOfPartialLiquidation";
    TsxEmailTemplateName["cryptoNoticeOfFullLiquidation"] = "cryptoNoticeOfFullLiquidation";
    // ======= Crypto Transactional =======
    TsxEmailTemplateName["cryptoBitcoinDepositComplete"] = "cryptoBitcoinDepositComplete";
    TsxEmailTemplateName["cryptoReferralPayoutReferee"] = "cryptoReferralPayoutReferee";
    TsxEmailTemplateName["cryptoReferralPayoutReferrer"] = "cryptoReferralPayoutReferrer";
    TsxEmailTemplateName["cryptoBitcoinCardCrossPromo"] = "cryptoBitcoinCardCrossPromo";
    TsxEmailTemplateName["cryptoReferralInvite"] = "cryptoReferralInvite";
    TsxEmailTemplateName["cryptoBitcoinWithdrawalInProgress"] = "cryptoBitcoinWithdrawalInProgress";
    TsxEmailTemplateName["cryptoPaymentReceived"] = "cryptoPaymentReceived";
    TsxEmailTemplateName["cryptoPaymentDue"] = "cryptoPaymentDue";
    TsxEmailTemplateName["cryptoPaymentPastDue"] = "cryptoPaymentPastDue";
    TsxEmailTemplateName["cryptoPaymentReminder24hrAutoPay"] = "cryptoPaymentReminder24hrAutoPay";
    TsxEmailTemplateName["cryptoPaymentReminder24hrNoAutoPay"] = "cryptoPaymentReminder24hrNoAutoPay";
    // ======= Crypto Origination / NOI =======
    TsxEmailTemplateName["cryptoNoticeOfIncompleteness"] = "cryptoNoticeOfIncompleteness";
    TsxEmailTemplateName["retargetingAvenCash"] = "retargetingAvenCash";
    TsxEmailTemplateName["retargetingBalanceTransfer"] = "retargetingBalanceTransfer";
    TsxEmailTemplateName["retargetingThreePercentCashBack"] = "retargetingThreePercentCashBack";
    TsxEmailTemplateName["retargetingCreditCardRefi"] = "retargetingCreditCardRefi";
    TsxEmailTemplateName["retargetingPlRefi"] = "retargetingPlRefi";
    TsxEmailTemplateName["retargetingHelocRefi"] = "retargetingHelocRefi";
    TsxEmailTemplateName["retargetingPayCalcZero"] = "retargetingPayCalcZero";
    // ======= Mortgage Drip =======
    TsxEmailTemplateName["mortgageDenialOfferDrip"] = "mortgageDenialOfferDrip";
    // ======= AAN with Mortgage Offer =======
    TsxEmailTemplateName["adverseActionMortgageOffer"] = "adverseActionMortgageOffer";
    // ======= AAN with HIL Rewards Downgrade Offer =======
    TsxEmailTemplateName["correctedAdverseActionNotice"] = "correctedAdverseActionNotice";
    TsxEmailTemplateName["adverseActionRewardsOffer"] = "adverseActionRewardsOffer";
    // ======= Crypto Persona AFC Verification =======
    TsxEmailTemplateName["cryptoPersonaAfcVerification"] = "cryptoPersonaAfcVerification";
    // ======= Crypto Bitcoin Deposit Drip =======
    TsxEmailTemplateName["cryptoBitcoinDepositDrip"] = "cryptoBitcoinDepositDrip";
    // ======= Crypto Reduce Limit Deposit Drip =======
    TsxEmailTemplateName["cryptoReduceLimitDepositDrip"] = "cryptoReduceLimitDepositDrip";
    // ======= Crypto Waitlist =======
    TsxEmailTemplateName["cryptoWaitlistConfirmation"] = "cryptoWaitlistConfirmation";
    // ======= APR Drop Celebration =======
    TsxEmailTemplateName["aprDropNotification"] = "aprDropNotification";
    TsxEmailTemplateName["resurrectionAprReduction"] = "resurrectionAprReduction";
    // ======= Late Fee Reversal Courtesy =======
    TsxEmailTemplateName["lateFeeReversalPending"] = "lateFeeReversalPending";
    // ======= Fraud Pending Document Drip =======
    TsxEmailTemplateName["fraudPendingDocument"] = "fraudPendingDocument";
    // ======= Update Card Courtesy Transaction =======
    TsxEmailTemplateName["updateCardCourtesyTransaction"] = "expiredCardCourtesyNotification";
    // ======= Rewards BT Upsell Upcoming Payment Due Sweep Drip =======
    TsxEmailTemplateName["rewardsBtUpsellUpcomingPaymentDueSweep"] = "rewardsBtUpsellUpcomingPaymentDueSweep";
    // ======= UCC Rewards Offer Drip =======
    TsxEmailTemplateName["uccRewardsOfferNotAccepted"] = "uccRewardsOfferNotAccepted";
    // ======= UCC Rewards Welcome Drip =======
    TsxEmailTemplateName["uccRewardsWelcome"] = "uccRewardsWelcome";
    // ======= UCC Rewards Ready to Activate Drip =======
    TsxEmailTemplateName["uccRewardsReadyToActivate"] = "uccRewardsReadyToActivate";
    // ======= Purchase First-Lien HELOC Settlement =======
    TsxEmailTemplateName["titleSettlementOrder"] = "titleSettlementOrder";
    // ======= FLP Asset Verification =======
    TsxEmailTemplateName["assetVerificationDocumentRequest"] = "assetVerificationDocumentRequest";
    // ======= BiggerPockets Pro Membership Statement Credit =======
    TsxEmailTemplateName["biggerPocketsStatementCreditGranted"] = "biggerPocketsStatementCreditGranted";
    // ======= Purchase HELOC Asset Verification Document Reverification =======
    TsxEmailTemplateName["purchaseHelocDocumentReverification"] = "purchaseHelocDocumentReverification";
    // ======= Debt Swap Unswappable Tradelines =======
    TsxEmailTemplateName["debtSwapUnswappableTradelines"] = "debtSwapUnswappableTradelines";
    // ======= Plaid Income Verification OGC Fallback Drip =======
    TsxEmailTemplateName["plaidIncomeDocReviewFailed"] = "plaidIncomeDocReviewFailed";
    // ======= Cashback Boost Deposit Bundle Funding Reminder Drip =======
    TsxEmailTemplateName["cashbackBoostDepositBundleFundingReminder"] = "cashbackBoostDepositBundleFundingReminder";
    // ======= Applicant Employment Verification Condition =======
    TsxEmailTemplateName["employmentVerificationConditionApplicantDocRequest"] = "employmentVerificationConditionApplicantDocRequest";
    // ======= Early Bank Connection Statement Rejected =======
    TsxEmailTemplateName["externalBankAccountVerificationRejected"] = "externalBankAccountVerificationRejected";
    // ======= Applicant Hazard Insurance Condition =======
    TsxEmailTemplateName["hazardInsuranceConditionApplicantNotification"] = "hazardInsuranceConditionApplicantNotification";
    TsxEmailTemplateName["hazardInsuranceConditionApplicantRejectionNotification"] = "hazardInsuranceConditionApplicantRejectionNotification";
    // ======= Cardholder Deferred Hazard Insurance Reminder =======
    TsxEmailTemplateName["deferredHazardInsuranceReminder"] = "deferredHazardInsuranceReminder";
    // ======= Applicant Title Insurance Condition =======
    TsxEmailTemplateName["titleInsuranceConditionApplicantRejectionNotification"] = "titleInsuranceConditionApplicantRejectionNotification";
    TsxEmailTemplateName["titleInsuranceConditionApplicantDocRequest"] = "titleInsuranceConditionApplicantDocRequest";
    TsxEmailTemplateName["lienPositionReviewConditionApplicantDocRequest"] = "lienPositionReviewConditionApplicantDocRequest";
    // ======= Applicant Prior Lien Release Documents Condition =======
    TsxEmailTemplateName["priorLienReleaseDocumentsConditionApplicantNotification"] = "priorLienReleaseDocumentsConditionApplicantNotification";
    TsxEmailTemplateName["priorLienReleasePayoffQuoteCleared"] = "priorLienReleasePayoffQuoteCleared";
    // ======= Loan Officer Trust Verification Condition =======
    TsxEmailTemplateName["trustVerificationConditionLoNotification"] = "trustVerificationConditionLoNotification";
    TsxEmailTemplateName["trustVerificationConditionClearedLoNotification"] = "trustVerificationConditionClearedLoNotification";
    TsxEmailTemplateName["applicantIdentityVerificationConditionLoNotification"] = "applicantIdentityVerificationConditionLoNotification";
    TsxEmailTemplateName["applicantIdentityVerificationConditionClearedLoNotification"] = "applicantIdentityVerificationConditionClearedLoNotification";
    // ======= Removed Co-owner Condition =======
    TsxEmailTemplateName["removedCoOwnerConditionApplicantRejectionNotification"] = "removedCoOwnerConditionApplicantRejectionNotification";
    TsxEmailTemplateName["removedCoOwnerConditionLoNotification"] = "removedCoOwnerConditionLoNotification";
    TsxEmailTemplateName["removedCoOwnerConditionClearedLoNotification"] = "removedCoOwnerConditionClearedLoNotification";
    // ======= SuperCLI Invite Reminders =======
    TsxEmailTemplateName["superCliInviteEngagementReminder"] = "superCliInviteEngagementReminder";
    TsxEmailTemplateName["superCliInviteDropoffReminder"] = "superCliInviteDropoffReminder";
    // ======= HIL AutoPay Enrollment Reminder =======
    TsxEmailTemplateName["hilAutopayEnrollmentReminder"] = "hilAutopayEnrollmentReminder";
    // ======= HIL Rewards to Home Payoff =======
    TsxEmailTemplateName["hilRewardsToHomePayoff"] = "hilRewardsToHomePayoff";
})(TsxEmailTemplateName || (exports.TsxEmailTemplateName = TsxEmailTemplateName = {}));
/**
 * Array of all TSX email template names.
 * Used for runtime validation (e.g., Joi schemas) and UI dropdowns.
 */
exports.TSX_EMAIL_TEMPLATE_NAMES = Object.values(TsxEmailTemplateName);
